<template>
  <div>
    <!-- <div class="iframe-container">
      <iframe :src="url" frameBorder="0" class="h-100 w-100"></iframe>
    </div> -->
  </div>
</template>

<script>
import practiceSuiteServer from "../../server/practiceSuite";

export default {
  name: "PracticeSuiteIndex",
  props: ["showing"],
  data() {
    return {
      url: "",
      token:
        "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJzY29wZSI6WyJyZWFkIl0sInBhcnRuZXJJZCI6IlBTIiwiZXhwIjoxNjE4ODU5ODc2LCJhdXRob3JpdGllcyI6WyJST0xFX0NMSUVOVCJdLCJqdGkiOiIxNTczMzJkZi05MzFjLTRjMzYtYjcwMC05YmRjNzczYmJjNGYiLCJhY2NvdW50IjpbXSwicHJvY2Vzc0VuZ2luZSI6IlBTIiwiY2xpZW50X2lkIjoicHMtaW50ZXJmYWNlLWNsaWVudC1vcHVzc2JveCJ9.zocrCDY1NHQ2WLdJoZ20iLcn_sYxXcjFvPC0uCyOcLjTH9fLR306NicL2dt7fUzX76smciMzIBikef8aGdnQk28dALgV5OcQI4_MXELhkf1Dew37MkVRa7vmy6dcBchv2oUTBxKvrEPickRl20Hqtv3x5xfUx-IwXiU2cGuy2ZHp0JbmfZYuJrlyUCh786OzrOKrpltVzad2npXAoEGKSQY-gNIIp8b_2U2gXbfQC9P7m5Ly29w5DLhcfjnLMER8Pi3wQGNQPcvlmaGmxoziDXHz1J9VftnScTBPHd34Di_Ozp3aJYpL4tRAeF-GgQ8G2G-PG30wr1gv0hKLSZ8bbw"
    };
  },
  methods: {
    async getUrlData() {
      const urlDataResult = await practiceSuiteServer.getUrlData();
      this.token = urlDataResult.accessToken;
      var xhr = new XMLHttpRequest();

      xhr.open("GET", urlDataResult.clientUrl);
      xhr.onreadystatechange = handler;
      xhr.responseType = "blob";
      xhr.setRequestHeader("Authorization", "Bearer " + this.token);
      xhr.send();
      const self = this;
      function handler() {
        if (this.readyState === this.DONE) {
          if (this.status === 200) {
            // this.response is a Blob, because we set responseType above
            self.url = URL.createObjectURL(this.response);
            window.open(self.url, "_blank").focus();
          } else {
            console.error("no pdf :(");
          }
        }
      }
    }
  },
  watch: {
    showing: function(newValue) {
      if (newValue) {
        this.getUrlData();
      }
    }
  }
};
</script>

<style scoped>
.iframe-container {
  height: calc(100vh - 107px);
}
</style>
